import { AttachType, PurchaseMessages } from '$store/models';
import { useEffect, useState } from 'react';
import { SelectItem } from '$uikit/ListOfButtonSelect/ListOfButtonSelect.interface';
import { TabId } from '$core/MediaChat/MediaChat.interface';

export const useListOfSecondFilters = (media: PurchaseMessages | null, type: TabId) => {
  const [listOfSecondFilters, setListOfSecondFilters] = useState<
    SelectItem<AttachType | 'all'>[]
  >([filters.all]);

  const hasAttachment = (media, attachType: AttachType) => {
    for (let i = 0; i < media[type].length; i++) {
      const item = media.content[media[type][i]];

      if (item.attach.type === attachType) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (media === null) {
      return;
    }

    const newFilters: SelectItem<AttachType | 'all'>[] = [filters.all];
    const hasPhotoAttachment = hasAttachment(media, AttachType.PHOTO);
    const hasVideoAttachment = hasAttachment(media, AttachType.VIDEO);

    if (hasPhotoAttachment) {
      newFilters.push(filters.photo);
    }
    if (hasVideoAttachment) {
      newFilters.push(filters.video);
    }

    setListOfSecondFilters(newFilters);
  }, [media, type]);

  return listOfSecondFilters;
};

interface Filters {
  all: SelectItem<'all'>;
  photo: SelectItem<AttachType>;
  video: SelectItem<AttachType>;
}

const filters: Filters = {
  all: {
    label: 'media_filter_all',
    value: 'all',
  },
  photo: {
    label: 'media_filter_photo',
    value: AttachType.PHOTO,
  },
  video: {
    label: 'media_filter_video',
    value: AttachType.VIDEO,
  },
};
